import { FastRepliesHotKey, hotKeyEmpty, HotKeyValues } from "../../../models/fastRepliesHotKeys"
import keycode from "keycode"
import { keyMapping } from "../../HotKeysExtensionForm/HotKeysExtensionForm.const"

export const toHotKeyValues = (hotKey?: FastRepliesHotKey): HotKeyValues => {
    return hotKey
        ? {
              FirstKey: keycode(hotKey.FirstKey).toUpperCase(),
              SecondKey: getSecondCombinationChar(hotKey?.CombinationName).toUpperCase()
          }
        : hotKeyEmpty
}

export const getLatinCharCode = (char: string): number | null => {
    if (char.length !== 1) {
        return null
    }

    const cyrillicRegex = /^[а-я]$/gi
    const isCyrillic = !!char.match(cyrillicRegex)
    let latinChar = isCyrillic ? "" : char.toUpperCase()

    if (isCyrillic) {
        for (const mapping of Object.values(keyMapping)) {
            if (mapping.ru.toUpperCase() === char.toUpperCase()) {
                latinChar = mapping.en.toUpperCase()
                break
            }
        }
    }

    return keycode(latinChar)
}

export const getSecondCombinationChar = (combinationName = ""): string => {
    const secondCombinationChar = combinationName.split("+").pop()

    if (!secondCombinationChar) {
        return ""
    }

    return secondCombinationChar
}
